import React from "react";

// svg only
function PersonalLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsOsb="http://www.openswatchbook.org/uri/2009/osb"
      width="210mm"
      height="297mm"
      version="1.1"
      viewBox="0 0 210 297"
      className="personal_logo"
    >
      <defs>
        <linearGradient osbPaint="solid">
          <stop offset="0" stopColor="#dd4c65" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient osbPaint="gradient">
          <stop offset="0" stopColor="#000" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#000" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient osbPaint="solid">
          <stop offset="0" stopColor="#000" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient osbPaint="solid">
          <stop offset="0" stopColor="#30475e" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient osbPaint="gradient">
          <stop offset="0" stopColor="#f77067" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f77067" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
      <g>
        <g fillOpacity="1" transform="matrix(.84585 0 0 .84585 9.008 27.86)">
          <g
            fill="#f77067"
            strokeWidth="0.275"
            transform="translate(-12.5 -11)"
          >
            <rect
              width="40"
              height="115"
              x="61"
              y="-141.5"
              rx="23.019"
              ry="23.019"
              transform="rotate(90)"
            ></rect>
            <rect
              width="40"
              height="115"
              x="64"
              y="86"
              rx="23.019"
              ry="23.019"
            ></rect>
          </g>
          <g
            fill="#f58a66"
            strokeWidth="0.275"
            transform="translate(-12.5 -11)"
          >
            <rect
              width="40"
              height="115"
              x="68"
              y="-134.5"
              rx="23.019"
              ry="23.019"
              transform="rotate(90)"
            ></rect>
            <rect
              width="40"
              height="115"
              x="57"
              y="93"
              rx="23.019"
              ry="23.019"
            ></rect>
          </g>
          <rect
            width="40"
            height="115"
            x="37.5"
            y="89"
            fill="#f2a365"
            strokeWidth="0.275"
            rx="23.019"
            ry="23.019"
          ></rect>
          <rect
            width="40"
            height="115"
            x="64"
            y="-115"
            fill="#f2a365"
            strokeWidth="0.275"
            rx="23.019"
            ry="23.019"
            transform="rotate(90)"
          ></rect>
          <g
            fill="#f2a365"
            strokeWidth="0.275"
            transform="translate(-12.5 -11)"
          >
            <rect
              width="40"
              height="115"
              x="50"
              y="100"
              rx="23.019"
              ry="23.019"
            ></rect>
            <rect
              width="40"
              height="115"
              x="75"
              y="-127.5"
              rx="23.019"
              ry="23.019"
              transform="rotate(90)"
            ></rect>
          </g>
          <g fillRule="evenodd" stroke="none" strokeOpacity="1">
            <g fill="#f77067" transform="translate(12.38 -34.116)">
              <rect
                width="40"
                height="140"
                x="116.619"
                y="84.116"
                strokeWidth="0.266"
                rx="22.584"
                ry="22.584"
              ></rect>
              <rect
                width="40"
                height="100"
                x="199.786"
                y="-25.527"
                strokeWidth="0.225"
                rx="22.584"
                ry="22.584"
                transform="rotate(30)"
              ></rect>
              <rect
                width="40"
                height="100"
                x="-86.282"
                y="-294.174"
                strokeWidth="0.225"
                rx="22.584"
                ry="22.584"
                transform="rotate(150)"
              ></rect>
            </g>
            <g fill="#f58a66" transform="translate(5.38 -27.116)">
              <rect
                width="40"
                height="140"
                x="116.619"
                y="84.116"
                strokeWidth="0.266"
                rx="22.584"
                ry="22.584"
              ></rect>
              <rect
                width="40"
                height="100"
                x="199.786"
                y="-25.527"
                strokeWidth="0.225"
                rx="22.584"
                ry="22.584"
                transform="rotate(30)"
              ></rect>
              <rect
                width="40"
                height="100"
                x="-86.282"
                y="-294.174"
                strokeWidth="0.225"
                rx="22.584"
                ry="22.584"
                transform="rotate(150)"
              ></rect>
            </g>
            <g fill="#f2a365" transform="translate(-1.62 -20.116)">
              <rect
                width="40"
                height="140"
                x="116.619"
                y="84.116"
                strokeWidth="0.266"
                rx="22.584"
                ry="22.584"
              ></rect>
              <rect
                width="40"
                height="100"
                x="199.786"
                y="-25.527"
                strokeWidth="0.225"
                rx="22.584"
                ry="22.584"
                transform="rotate(30)"
              ></rect>
              <rect
                width="40"
                height="100"
                x="-86.282"
                y="-294.174"
                strokeWidth="0.225"
                rx="22.584"
                ry="22.584"
                transform="rotate(150)"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default PersonalLogo;
